import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useDocument } from 'components/hooks';
import { HeadlinePage, MarkdownRenderer } from 'components/common';
import { documentationPolicies } from 'helpers';
import { useStyle } from './styles';
import { useTranslation } from 'react-i18next';
import {
  Paper,
  CircularProgress,
  Backdrop,
  Typography,
  Grid
} from '@mui/material';
import { ROUTES } from 'consts';


export default function DocumentViewDumb({ defaultValues, isEdit, viewingDocument }) {
  const { isLoaded } = useDocument();
  const classes = useStyle();
  const [t] = useTranslation();
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const { reset } = methods;

  useEffect(() => {
    if (isEdit) reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  const handleDownloadFile = () => {
    console.log(defaultValues);

    let tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = defaultValues.document;

    const textLog =  tempDivElement.textContent || tempDivElement.innerText || "";
    const url = window.URL.createObjectURL(new Blob([textLog]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `${viewingDocument}`,
    );
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }

  // Detect if content is HTML or Markdown
  const detectContentType = (content) => {
    if (!content) return 'markdown';
    const htmlPattern = /<\/?[a-z][\s\S]*>/i;
    return htmlPattern.test(content) ? 'html' : 'markdown';
  };

  const contentType = detectContentType(defaultValues?.document);

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoaded.get}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage title={ 'documentView.headline' } goBack={ ROUTES.DOCUMENTATION_LIST }/>

      <Paper className={classes.paperStyle}>
        <Typography variant="h6" sx={{ padding: '8px 0px 0px 0px' }}>
          {t('inventoryList.form.title')}
        </Typography>

        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} lg={12} md={12} >
            <Typography variant="subtitle1">
              {t('documentationList.form.name.label')}
            </Typography>
            <Typography variant="body1">
              {viewingDocument}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} lg={12} md={12} >
            <MarkdownRenderer
              content={defaultValues?.document || ''}
              contentType={contentType}
              label={documentationPolicies.document.label}
              height="600px"
              showToggle={true}
              defaultView="rendered"
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}
